import React from "react";
import { useTranslation } from "react-i18next";
import useVersionCheck from "../../../utils/useVersionCheck";

const UpdateBanner = () => {
  const { t } = useTranslation();
  const updateAvailable = useVersionCheck();

  if (!updateAvailable) return null;

  return (
    <div
      style={{
        position: "fixed",
        bottom: 24,
        right: 24,
        zIndex: 9999,
        maxWidth: 360,
      }}
    >
      <div className="alert alert-primary d-flex align-items-center shadow mb-0" role="alert">
        <i className="ti ti-refresh-alert fs-18 me-2 flex-shrink-0" />
        <div className="flex-grow-1 me-2">
          <strong>{t("update available title", "Mise à jour disponible")}</strong>
          <div className="fs-12 text-muted">
            {t("update available subtitle", "Une nouvelle version de l'application est prête.")}
          </div>
        </div>
        <button
          type="button"
          className="btn btn-primary btn-sm flex-shrink-0"
          onClick={() => window.location.reload()}
        >
          {t("reload", "Recharger")}
        </button>
      </div>
    </div>
  );
};

export default UpdateBanner;
